<template>
    <generic-page>
        <ads-creator-dashboard />

        <div class="mt-2" v-if="brand.enableInviteRewards">
            <creator-dashboard-url />
        </div>

        <div class="mt-4 d-flex align-items-center justify-content-between">
            <h3 class="branded">Creator</h3>
            <b-btn
                v-if="brand.enableCreatorLivestream"
                @click="createLivestream"
                variant="light"
                pill
                class="border btn-brand"
            >
                <font-awesome-icon
                    icon="fa-solid fa-circle"
                    class="text-danger"
                />
                Go Live
            </b-btn>
        </div>

        <creator-review-prompt v-if="onboardingUser.creatorReviewPrompt" />

        <div class="mt-2">
            <creator-pending-credit-summary />

            <creator-fine-summary />
            <jackpot-summary v-if="brand.enableInviteRewards" />
            <spotlight-summary v-if="brand.enableCreatorVideo" />
            <creator-bonus-summary v-if="creatorUser?.bonusEligible" />
            <creator-earnings-summary />
            <creator-subscribers-summary
                v-if="brand.enableCreatorSubscription"
            />
            <creator-call-summary />
            <content-offer-summary v-if="creatorUser?.eligibleForContent" />
            <creator-livestream-summary v-if="brand.enableCreatorLivestream" />
            <creator-post-summary v-if="brand.enableCreatorPost" />
            <creator-gallery-summary v-if="brand.enableCreatorGallery" />
            <creator-invite-summary v-if="brand.enableInviteRewards" />
            <creator-requests-summary v-if="brand.enableRequest" />
            <creator-leaderboard-summary />
            <creator-rule-summary />
            <creator-guide-summary />
            <creator-help-summary />
        </div>
    </generic-page>
</template>


<script>
import JackpotSummary from "@/components/jackpot/JackpotSummary";

import AdsCreatorDashboard from "@/components/ads/AdsCreatorDashboard";
import CreatorReviewPrompt from "@/components/creator/review/CreatorReviewPrompt";
import CreatorCallSummary from "@/components/creator/call/CreatorCallSummary";
import CreatorFineSummary from "@/components/creator/fine/CreatorFineSummary";
import CreatorDashboardUrl from "@/components/creator/invite/CreatorDashboardUrl";
import CreatorEarningsSummary from "@/components/creator/earnings/CreatorEarningsSummary";
import CreatorInviteSummary from "@/components/creator/invite/CreatorInviteSummary";
import CreatorPostSummary from "@/components/creator/post/CreatorPostSummary";
import CreatorGallerySummary from "@/components/creator/gallery/CreatorGallerySummary";
import CreatorRequestsSummary from "@/components/creator/requests/CreatorRequestsSummary";
import CreatorHelpSummary from "@/components/creator/help/CreatorHelpSummary";
import CreatorRuleSummary from "@/components/creator/rule/CreatorRuleSummary";
import CreatorGuideSummary from "@/components/creator/guide/CreatorGuideSummary";
import CreatorPendingCreditSummary from "@/components/creator/pendingCredit/CreatorPendingCreditSummary";
import CreatorLivestreamSummary from "@/components/creator/livestream/CreatorLivestreamSummary";
import CreatorBonusSummary from "@/components/creator/bonus/CreatorBonusSummary";
import SpotlightSummary from "@/components/spotlight/SpotlightSummary";
import ContentOfferSummary from "@/components/creator/contentOffer/ContentOfferSummary";
// fix naming, moving quicky
import CreatorSubscribersSummary from "@/components/creator/subscriber/CreatorSubscribersSummary";

// old way
import CreatorLeaderboardSummary from "@/components/creator/summary/CreatorLeaderboardSummary";
import { mapState } from "vuex";

export default {
    mounted() {
        this.$store.dispatch("creatorDashboard/refresh");
        this.$store.dispatch("creatorGuide/refresh");
    },
    methods: {
        createLivestream() {
            this.$store.dispatch("creatorLivestream/create");
        },
    },
    computed: {
        isPreviewMode() {
            return (
                window.location.hostname === "preview.sugarchat.app" ||
                window.location.hostname === "web.sugarchat.app"
            );
        },
        enableGallery() {
            return this.brand.enableGallery;
        },
        enablePost() {
            return this.brand.enableFeed;
        },
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
        ...mapState("creatorDashboard", ["creatorUser"]),
        ...mapState("brand", ["brand"]),
    },
    components: {
        CreatorEarningsSummary,
        CreatorInviteSummary,
        CreatorRequestsSummary,
        CreatorCallSummary,
        CreatorHelpSummary,
        CreatorLeaderboardSummary,
        CreatorPendingCreditSummary,
        JackpotSummary,
        CreatorDashboardUrl,
        CreatorGallerySummary,
        CreatorFineSummary,
        CreatorGuideSummary,
        CreatorReviewPrompt,
        CreatorLivestreamSummary,
        CreatorBonusSummary,
        CreatorRuleSummary,
        CreatorPostSummary,
        AdsCreatorDashboard,
        SpotlightSummary,
        ContentOfferSummary,
        CreatorSubscribersSummary,
    },
};
</script>